export * from './offer-manager';
